import { message } from 'antd'
import { RatingApi } from 'api/Rating'
import AddRatingSystem from 'components/Main/RatingSystem/AddRating/AddRatingSystem'
import useFetch from 'elements/Hooks/useFetch'
import useModalData from 'elements/Hooks/useModalData'
import { get, isEmpty } from 'lodash'
import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'

function AddRatingSystemCont({ owner, match, templateKey }) {
  const key = owner || get(match, 'params.key')

  const { data, fetching, fetch } = useFetch({
    url: `/rating/owner/?id=${key}`,
    dependencyArray: key,
    suppressAlert: true,
  })

  const templateCode = templateKey || data.temperature
  const { data: template, fetching: fetchingTemplate, fetch: fetchTemplate } = useFetch({
    url: `/rating/template/${templateCode}`,
    dependencyArray: templateCode,
  })

  const { submitting, checkForm, removing, remove, formRef, update, setSubmitting } = useModalData(
    RatingApi.create,
    RatingApi.update,
    RatingApi.remove,
    () => []
  )

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await RatingApi.create({
        results: newObject,
        owner,
        template: templateKey,
      })

      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <AddRatingSystem
      {...{
        data,
        fetching: fetching || fetchingTemplate,
        template,
        fetch,
        owner,
        formRef,
        submit,
        update,
        isNew: isEmpty(data),
        removing,
        remove,
        submitting,
      }}
    />
  )
}

export default withRouter(AddRatingSystemCont)
